module.exports = __webpack_public_path__ + "img/pod2.61a0d07d.png";